import { createSlice } from "@reduxjs/toolkit";
import { set } from "lodash";
import { workflow_category_list } from "../../helpers/fakebackend_helper";

export const initialState = {
  node_list:[],
  workflow_loader:false,
  workflow_listing_loader:true,
  workflow_list:null,
  workflow_category:[],
  workflow_category_by_group:[],
  params_list:[]
  
 
};

const Workflowbuilder_Slice = createSlice({
  name: "Workflow_Builder",
  initialState,
  reducers: {
    set_workflow_node_list(state, action) {
      state.node_list=action.payload
    },
    set_workflow_listing_loader(state,action){
      state.workflow_listing_loader = action.payload
    },
     set_workflow_list(state,action){
      state.workflow_list = action.payload
    },
    set_workflow_loader(state,action){
     state.workflow_loader=action.payload
    },
    set_params_list(state,action){
      state.params_list =action.payload
    },
    set_workflow_category(state,action){
       state.workflow_category =  action.payload
    },

    set_workflow_category_by_group(state,action){
        state.workflow_category_by_group = action.payload
    },

     reset_workflowbuilder_reducer:() => initialState


     

  },
});

export const {
    set_workflow_node_list,
    set_workflow_loader,
    reset_workflowbuilder_reducer,
    set_workflow_listing_loader,
    set_workflow_list,
    set_params_list,
    set_workflow_category,
    set_workflow_category_by_group


} = Workflowbuilder_Slice.actions

export default Workflowbuilder_Slice.reducer;